import { CartLinesUpdateEvent } from '@shopify/events';

const roots = document.querySelectorAll('[data-remember-landing]');
roots.forEach((root) => {
  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  root.querySelectorAll('[data-remember-add]').forEach((button) => {
    button.addEventListener('click', async () => {
      const original = button.textContent;
      const id = Number(button.dataset.variantId);
      const quantity = Number(button.dataset.quantity || 1);
      const discountCode = button.dataset.discountCode || '';
      if (!id) { document.querySelector('#buy')?.scrollIntoView({ behavior: 'smooth' }); return; }
      button.disabled = true;
      button.textContent = 'Adding…';

      const routeRoot = window.Shopify.routes.root || '/';

      // Announce the pending add to the theme BEFORE the fetch, the same way
      // Atelier's own product-form.js does. cart-icon.js, cart-drawer.js and
      // component-cart-items.js all listen for this event and await its promise.
      const deferred = CartLinesUpdateEvent.createPromise();
      button.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(id), quantity }],
        promise: deferred.promise
      }));

      try {
        const response = await fetch(routeRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        if (!response.ok) throw new Error('Cart request failed');

        const cart = await fetch(routeRoot + 'cart.js').then((r) => r.json());

        // Resolve the promise the theme is awaiting -> cart bubble + drawer update.
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'remember-landing',
            itemCount: quantity,
            didError: false
          }
        });

        if (discountCode) {
          window.location.assign(`${routeRoot}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(routeRoot + 'cart')}`);
          return;
        }

        button.textContent = 'Added to cart';
        setTimeout(() => { button.textContent = original; button.disabled = false; }, 1600);
      } catch (error) {
        deferred.reject(error);
        button.textContent = 'Try again';
        button.disabled = false;
      }
    });
  });
});
